import { useContext } from "react"
import { CustomModal } from "../CustomModal/CustomModal"
import AccessContext from "../../context/AccessContext/AccessContext";
import { t } from "i18next";
import { DocumentDueList } from "./DocumentDueList";

export const DocumentDueModal = ({
    resourceDocumentsDue = [],
    contractorDocumentsDue = [],
    mainContractorsDocumentsDue = [],
    showModal,
    setShowModal,
}) => {

    const { accessState: { employee } } = useContext(AccessContext);

    return (
        <CustomModal
            showModal={showModal}
            setShowModal={setShowModal}
            centered
            title={t('DETAIL')}
            backgroundColor='#EFF7FE'
        >
            <div className="row row-cols-1 gap-3">

                {
                    resourceDocumentsDue?.length > 0 && (
                        <div className="col">
                            <DocumentDueList
                                documentsDue={resourceDocumentsDue}
                            />
                            {(contractorDocumentsDue?.length > 0 || mainContractorsDocumentsDue?.length > 0) && (
                                <hr />
                            )}
                        </div>
                    )
                }

                {
                    contractorDocumentsDue?.length > 0 && (
                        <div className="col">
                            <DocumentDueList
                                debtor={employee.contractor_name}
                                documentsDue={contractorDocumentsDue}
                            />
                            {(mainContractorsDocumentsDue.length > 0) && (
                                <hr />
                            )}
                        </div>
                    )
                }

                {
                    mainContractorsDocumentsDue?.length > 0 && (
                        <div className="col">
                            {
                                mainContractorsDocumentsDue.map((mainContractorsDocumentDue, idx) =>
                                    <DocumentDueList
                                        key={idx}
                                        debtor={`${mainContractorsDocumentDue.name} (${t('CONT_MAIN')})`}
                                        documentsDue={mainContractorsDocumentDue.due_documents}
                                    />
                                )
                            }
                        </div>
                    )
                }

            </div>
        </CustomModal>
    )
}
